import getSelectedTableView from './getSelectedTableView';
import { getFlagStatus, getUnreadCount } from '../selectors/mailListDataPropertyGetter';

export function getIsAnySelectedUnread(): boolean {
    return getIsAnySelectedState(getIsUnread);
}

export const getIsUnread = (rowId: string): boolean =>
    !!getUnreadCount(rowId, getSelectedTableView());

export function getIsAnySelectedUnflagged(): boolean {
    return getIsAnySelectedState(getIsUnflagged);
}

export const getIsUnflagged = (rowId: string): boolean =>
    !(getFlagStatus(rowId, getSelectedTableView()) === 'Flagged');

function getIsAnySelectedState(stateChecker: (id: string) => boolean): boolean {
    const tableView = getSelectedTableView();
    if (tableView.isInVirtualSelectAllMode) {
        for (const itemId of tableView.itemIds) {
            if (tableView.virutalSelectAllExclusionList.indexOf(itemId) < 0) {
                // Check state only if item is not in exclusion list
                if (stateChecker(itemId)) {
                    return true;
                }
            }
        }
    } else {
        for (const selectedItemId of [...tableView.selectedItemsIds.keys()]) {
            if (stateChecker(selectedItemId)) {
                return true;
            }
        }
    }

    return false;
}
